import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as myGlobals from '../../globals';
import { ConfigService } from '../../config.service';

@Injectable()
export class DispatcherHomeService {
  private _getoffers = myGlobals.apiurl + 'dispatcher/bookingHistory';
  private _getjobs = myGlobals.apiurl + 'dispatcher/booking/';
  private _singlebooking = myGlobals.apiurl + 'agents/jobs/';
  // private _cancelservice = myGlobals.apiurl + 'dispatcher/cancelBookingBeforeAccept';
  private _cancelserviceAfteraccept =
    myGlobals.apiurl + 'dispatcher/cancelBookingAfterAccept';
  private _onebookingdetails = '';
  private _dispatcherLivepath = myGlobals.apiurl + 'dispatcher/bookingPath/';
  // private _cancelreasons = myGlobals.apiurl + 'dispatcher/cancellationReasonCourier';
  private _cancelFee = myGlobals.apiurl + 'dispatcher/cancellationFees/';
  // private _negotiations = myGlobals.apiurl + 'dispatcher/bookingDetails/';
  private _counter = myGlobals.apiurl + 'dispatcher/respondToRequest';
  private _history =
    myGlobals.apiurl + 'agents/jobs/offers/negotiations/history';
  private _accept = myGlobals.apiurl + 'dispatcher/respondToRequest';
  private _getdetUrl = '';
  private _bookingCounter = myGlobals.apiurl + 'dispatcher/booking/count';
  private _pendingReviews = myGlobals.apiurl + 'dispatcher/pendingReview'; // remove
  private _ratingRide = myGlobals.apiurl + 'dispatcher/ratingTextCourier';
  private _reviewAndRating = myGlobals.apiurl + 'dispatcher/reviewAndRating';

  private _negotiations = myGlobals.apiurl + 'dispatcher/booking/';
  private _cancelreasons = myGlobals.apiurl + 'dispatcher/cancellationReason';
  private _cancelservice = myGlobals.apiurl + 'dispatcher/cancelByCustomer';

  private _unassignBooking = myGlobals.apiurl + 'dispatcher/unassignBooking';
  private _postDropLocation = myGlobals.apiurl + 'dispatcher/dropLocation';
  private _postDriverByNear = myGlobals.apiurl + 'dispatcher/driverByNear';
  private _dispatch_booking = myGlobals.apiurl + 'dispatcher/bookDriver';
  private _post_start_job = myGlobals.apiurl + 'booking/receiverVerificationCode';
  // private _getdetUrl = myGlobals.apiurl + 'slave/bookings';
  // private _cancelservice = myGlobals.apiurl + 'slave/cancelBooking';
  // private _onebookingdetails = myGlobals.apiurl + 'slave/bookings';

  private _addcards;
  private _deletecards;
  private _getcards;
  constructor(
    private _router: Router,
    private _http: HttpClient,
    private _conf: ConfigService
  ) { }

  createAuthorizationHeader(headers: HttpHeaders) {
    headers.append('authorization', sessionStorage.getItem('authtoken'));
  }

  // header = new HttpHeaders({ 'Content-Type': 'application/json','authorization': sessionStorage.getItem('authtoken') || '', 'lan': 'en' });
  // get booking details
  getBookingDetails(id, num = 3) {
    return this._http.get(`${this._getjobs}${id}/${num}`, {
      headers: this._conf.header
    });
  }
  // book driver
  dispatch_booking(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._dispatch_booking, body, {
      headers: this._conf.header
    });
  }

  // get nearest drivers
  nearest_drivers(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._postDriverByNear, body, {
      headers: this._conf.header
    });
  }

  // post drop location
  postDropLocation(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._postDropLocation, body, {
      headers: this._conf.header
    });
  }

  getdet(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    headers.append('lan', 'en');
    return this._http.get(this._getoffers, { headers: this._conf.header });
  }

  singleBooking(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.get(this._singlebooking + user.id, {
      headers: this._conf.header
    });
  }

  getjobs(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    headers.append('lan', 'en');
    const obj = {
      status: user.status,
      fromDate: user.fromDate,
      toDate: user.toDate,
      search: user.search
    };
    return this._http.post(
      this._getjobs +
      user.type +
      '/' +
      user.limit +
      '/' +
      user.skip +
      '/' +
      user.cityId,
      obj,
      { headers: this._conf.header }
    );
    // return this._http.post(this._getjobs + user.type +"/" + user.limit + '/' + user.skip + '/' + user.cityId, { headers: this._configservice.header })
  }

  // negotiations(user: any) {
  //     const body = JSON.stringify(user);
  //     const headers = new HttpHeaders();
  //     headers.append('Content-Type', 'application/json');
  //     headers.append('authorization', sessionStorage.getItem('authtoken'));
  //     headers.append('lan', 'en');
  //     return this._http.get(this._negotiations + user.bookingId + '/' +user.status, { headers: this._conf.header })
  //         .map(res => res.json())
  //         .map((res) => {
  //             return res;
  //         });
  // }
  negotiations(user: any) {
    // const body = JSON.stringify(user);
    // const headers = new HttpHeaders();
    // headers.append('Content-Type', 'application/json');
    // headers.append('authorization', sessionStorage.getItem('authtoken'));
    // headers.append('lan', 'en');
    console.log('callfrom--------->', user, user.callFrom);
    return this._http.get(
      this._negotiations + user.bookingId + '/' + user.status,
      {
        headers: this._conf.header
      }
    );
  }

  history(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    return this._http.post(this._history, body, { headers: this._conf.header });
  }
  counter_price(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    return this._http.post(this._counter, body, { headers: this._conf.header });
  }
  accept_price(user: any) {
    const body = JSON.stringify(user);
    const headers = new HttpHeaders();
    headers.append('authorization', sessionStorage.getItem('authtoken'));
    headers.append('Content-Type', 'application/json');
    headers.append('lan', 'en');
    return this._http.post(this._accept, body, { headers: this._conf.header });
  }
  cancelservice(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._cancelservice, body, {
      headers: this._conf.header
    });
  }

  getpendingreviews(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._pendingReviews, { headers: this._conf.header });
  }

  getratings(user: any) {
    const body = JSON.stringify(user);
    return this._http.get(this._ratingRide, { headers: this._conf.header });
  }

  postreview(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._reviewAndRating, body, {
      headers: this._conf.header
    });
  }

  cancelserviceAfterAccept(user: any) {
    const body = JSON.stringify(user);
    return this._http.put(this._cancelserviceAfteraccept, body, {
      headers: this._conf.header
    });
  }

  getsingalBooking(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._getdetUrl, body, {
      headers: this._conf.header
    });
  }

  livePath(user: any) {
    return this._http.get(this._dispatcherLivepath + user.bookingId, {
      headers: this._conf.header
    });
  }

  // GET Booking Count

  getBookingCounter(user: any) {
    const obj = {
      status: user.status,
      fromDate: user.fromDate,
      toDate: user.toDate,
      search: user.search
    };
    return this._http.post(this._bookingCounter + '/' + user.cityId, obj, {
      headers: this._conf.header
    });
  }

  // cancel reasons
  cancelreasons(user: any) {
    return this._http.get(
      this._cancelreasons +
      '/' +
      user.entityType +
      '/' +
      user.serviceType +
      '/' +
      user.type,
      { headers: this._conf.header }
    );
  }

  // cancellation fees
  cancelfees(user: any) {
    return this._http.get(this._cancelFee + user.bookingId, {
      headers: this._conf.header
    });
  }

  // book driver
  unassignBooking(user: any) {
    const body = JSON.stringify(user);
    return this._http.post(this._unassignBooking, body, {
      headers: this._conf.header
    });
  }

  postJobStartByDriver(user: any) {
    return this._http.post(this._post_start_job, user, {
      headers: this._conf.header
    });
  }
}
